import React, { useEffect, useState } from "react";
import close from "../../../assets/svg/close.svg";
import DOMPurify from 'dompurify';
import { createVehicleTypeApi, getVehicleTypeApi, updateVehicleTypApi } from "../master-api";
import { Container, Row, Col } from "react-bootstrap";
import CommonAsyncSelect from "../../common/custom-select";
import { getDeptApi, getLocationApi, getProductTypeApi } from "../customers/customer-api";
import plus from "../../../assets/svg/plus.svg";
import "./vehiclelist.css";
import closeIcon from "../../../assets/svg/close-red.svg";

function VehicleAdd({ typeId, onSuccess, onClose }) {
  /*  useEffect(() => {
     if (show) {
       document.body.classList.add("modal-open");
     } else {
       document.body.classList.remove("modal-open");
     }
     return () => document.body.classList.remove("modal-open");
   }, [show]);
 
   if (!show) return null; */
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);
  const [productTypeList, setProductTypeList] = useState([{id:'', product_types:[],  load_in: "", load_out: "", lag: "",}]);
const [productTypeRemovedId, setProductTypeRemovedId] = useState([]);

  const handleLocationChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedLocation(selectedOptions);
  };
  const handleDeptChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedDept(selectedOptions);
  };
  const getLocationData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getLocationApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };
  const getDepartmentData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getDeptApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };
  const handleProductTypeChange = (index,selectedOptions) => {
    console.log(selectedOptions);
     const tempList=[...productTypeList];
    tempList[index].product_types=selectedOptions;
    setProductTypeList(tempList);
  };

  const [cachedOptions, setCachedOptions] = React.useState([]);
  const getProductTypeData = async (inputValue, currentRowIndex = null) => {
    try {
      const response = await getProductTypeApi("", inputValue || "");
      if (response?.status === 200 && response?.data?.success === true) {
        const allList = (response.data.suggestionlist || []).map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));

        const otherSelectedUuids = new Set(
          productTypeList
            .filter((item, idx) => (currentRowIndex !== null ? idx !== currentRowIndex : true))
            .flatMap((item) => (item.product_types || []).map((product) => (typeof product === "object" ? product?.value : product)))
            .filter(Boolean)
        );

        return allList.filter((opt) => !otherSelectedUuids.has(opt.value));
      }
    } catch (err) {
      console.error("Error fetching product types:", err);
    }
    return [];
  };
  const handleMenuOpen = (index) => {
    getProductTypeData("", index).then((options) => setCachedOptions(options || []));
  };

  const apiUrl = process.env.REACT_APP_API_URL;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [typeCode, setTypeCode] = useState("");
  const [typeName, setTypeName] = useState("");
  const [dimension, setDimension] = useState("meter");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [loadInDuration, setLoadInDuration] = useState("");
  const [loadOutDuration, setLoadOutDuration] = useState("");
  const [lagDuration, setLagDuration] = useState("");
  const [lastKey, setLastKey] = useState("");

  const formatTimeOnBlur = (value) => {
    if (!value || typeof value !== "string") return "";
    let trimmed = value.trim();
    if (!trimmed) return "";

    if (/^\d{1,2}$/.test(trimmed)) {
      const num = parseInt(trimmed, 10);
      if (num >= 0 && num <= 23) {
        return `${String(num).padStart(2, "0")}:00`;
      }
      return trimmed;
    }

    if (trimmed.includes(":")) {
      const parts = trimmed.split(":");
      let hours = parts[0] ? parts[0].trim() : "0";
      let minutes = parts[1] ? parts[1].trim() : "0";

      let hNum = parseInt(hours, 10);
      let mNum = parseInt(minutes, 10);

      if (!isNaN(hNum) && !isNaN(mNum)) {
        if (hNum >= 0 && hNum <= 23 && mNum >= 0 && mNum <= 59) {
          return `${String(hNum).padStart(2, "0")}:${String(mNum).padStart(2, "0")}`;
        }
      }
    }
    return trimmed;
  };

  const validateTimeFormat = (timeStr, isRequired = false, fieldName = "Time") => {
    if (!timeStr || !timeStr.trim()) {
      if (isRequired) return `${fieldName} is required`;
      return "";
    }
    const formatted = formatTimeOnBlur(timeStr);
    const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!regex.test(formatted)) {
      return "Enter valid time in HH:MM format (00:00 - 23:59)";
    }
    return "";
  };

  useEffect(() => {
    if (typeId != null && typeId !== "") {
      getVehicleType();
    }
  }, [typeId]);

  const getVehicleType = async () => {
    try {
      const response = await getVehicleTypeApi(typeId);
      if (response?.data?.success === true) {
        const vehicleTypeData = response.data.vehicle_type;
        setTypeCode(vehicleTypeData.code || "");
        setTypeName(vehicleTypeData.name || "");
        setDimension(vehicleTypeData.dimension || "meter");
        setLength(vehicleTypeData.length != null ? String(vehicleTypeData.length) : "");
        setWidth(vehicleTypeData.width != null ? String(vehicleTypeData.width) : "");
        setHeight(vehicleTypeData.height != null ? String(vehicleTypeData.height) : "");
        setLoadInDuration(vehicleTypeData.load_in_time || "");
        setLoadOutDuration(vehicleTypeData.load_out_time || "");
        setLagDuration(vehicleTypeData.lag_duration || "");

        const locations = Array.isArray(vehicleTypeData.locations)
          ? vehicleTypeData.locations.map(item => ({
              value: String(item.value || item.id || item.uuid || ''),
              label: String(item.label || item.location_name || item.name || '')
            }))
          : [];
        setSelectedLocation(locations);

        const departments = Array.isArray(vehicleTypeData.departments)
          ? vehicleTypeData.departments.map(item => ({
              value: String(item.value || item.id || item.uuid || ''),
              label: String(item.label || item.department_name || item.name || '')
            }))
          : [];
        setSelectedDept(departments);

        if (Array.isArray(vehicleTypeData.durations) && vehicleTypeData.durations.length > 0) {
          const mappedDurations = vehicleTypeData.durations.map((d) => ({
            id: d.id || "",
            load_in: d.load_in || "",
            load_out: d.load_out || "",
            lag: d.lag || "",
            product_types: Array.isArray(d.product_types)
              ? d.product_types.map((p) => ({
                  value: String(p.value || p.id || p.uuid || ""),
                  label: String(p.label || p.name || p.code || "")
                }))
              : [],
          }));
          setProductTypeList(mappedDurations);
        } else {
          setProductTypeList([{ id: '', product_types: [], load_in: "", load_out: "", lag: "" }]);
        }
      }
      return response?.data;
    } catch (err) {
      console.error("Error fetching vehicle type details:", err);
    }
  };
  const [validations, setValidations] = useState({
    code: "",
    name: "",
    dimension: "",
    length: "",
    width: "",
    height: "",
    load_in_time: "",
    load_out_time: "",
    lag_duration: "",
    locations: "",
    departments: "",
  });

  const submitVehicleType = async () => {
    // Client-side validations
    const loadInErr = validateTimeFormat(loadInDuration, true, "Load In");
    const loadOutErr = validateTimeFormat(loadOutDuration, true, "Load Out");
    const lagErr = lagDuration ? validateTimeFormat(lagDuration, false, "Lag Duration") : "";

    if (loadInErr || loadOutErr || lagErr || !typeCode.trim() || !typeName.trim()) {
      setValidations((prev) => ({
        ...prev,
        code: !typeCode.trim() ? "Code is required" : "",
        name: !typeName.trim() ? "Name is required" : "",
        load_in_time: loadInErr,
        load_out_time: loadOutErr,
        lag_duration: lagErr,
      }));
      if (loadInErr || loadOutErr || lagErr || !typeCode.trim() || !typeName.trim()) {
        return;
      }
    }

    setIsSubmitting(true);
    try {
      const dataBeforeSanitize = {
        id: typeId,
        code: typeCode,
        name: typeName,
        dimension: dimension,
        length: length,
        width: width,
        height: height,
        load_in_time: formatTimeOnBlur(loadInDuration),
        load_out_time: formatTimeOnBlur(loadOutDuration),
        lag_duration: formatTimeOnBlur(lagDuration) || "00:00",
        locations: selectedLocation.map(item => item.value),
        departments: selectedDept.map(item => item.value),
        removed_durations: productTypeRemovedId,
        durations: productTypeList
          .filter((item) => (item.product_types && item.product_types.length > 0) || item.load_in || item.load_out)
          .map((item) => ({
            id: item.id || null,
            load_in: formatTimeOnBlur(item.load_in),
            load_out: formatTimeOnBlur(item.load_out),
            lag: formatTimeOnBlur(item.lag) || "00:00",
            product_type_id: (item.product_types || []).map((product) => (typeof product === 'object' ? product.value : product)),
          }))
      };
      const dataAfterSanitize = {};
      Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === 'assignee') {
          dataAfterSanitize[key] = value;
        } else {
          dataAfterSanitize[key] = DOMPurify.sanitize(value);
        }
      });

      let response;
      if (!typeId || typeId === "") {
        response = await createVehicleTypeApi(dataAfterSanitize);
      } else {
        response = await updateVehicleTypApi(typeId, dataAfterSanitize);
      }

      if (response && response.status === 200) {
        if (response.data.success === true) {
          onSuccess(response.data);
        }
      }
      if (response && response.status === 400 && response.data?.error) {
        const validationTemp = {
          code: "",
          name: "",
          dimension: "",
          length: "",
          width: "",
          height: "",
          load_in_time: "",
          load_out_time: "",
          lag_duration: "",
          locations: "",
          departments: "",
        };
        Object.entries(response.data.error).forEach(([key, value]) => {
          validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : (typeof value === 'string' ? value : '');
        });
        setValidations(validationTemp);
      }
    } catch (error) {
      console.error("Error saving vehicle type:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      borderRadius: "16px",
      padding: "24px",
      backgroundColor: "#fff",
      width: "100%",
      maxWidth: "900px",
      maxHeight: "90vh",
      height: "auto",
      overflowY: "auto",
    },
  };
  return (
    <div
      style={modalStyle.overlay}
    >
      <div
        style={modalStyle.modal}
      >
        <div >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <h5
              style={{
                fontFamily: "Epilogue",
                fontWeight: 700,
                fontSize: "20px",
                margin: 0,
              }}
            >
              Add vehicle type
            </h5>
            <button
              type="button"
              onClick={onClose}
              style={{
                background: "none",
                border: "1px solid #D4DDE7",
                borderRadius: "100px",
                padding: "8px",
                height: "40px",
                width: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <img
                src={close}
                alt="Close"
                style={{ width: "14px", height: "14px" }}
              />
            </button>
          </div>

          {/* Body */}
          <form>
            <Row className="px-0 mx-0">
              <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Code<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={typeCode}
                  onChange={(event) => {
                    setTypeCode(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error" >{validations.code}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Name<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={typeName}
                  onChange={(event) => {
                    setTypeName(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error" >{validations.name}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
                <div className="field-title">
                  Location
                  {/* <span style={{ color: "#FF4444" }}>*</span> */}
                </div>
                <CommonAsyncSelect isMulti cacheOptions value={selectedLocation} loadOptions={getLocationData} onChange={handleLocationChange} defaultOptions placeholder="Select locations" />
                <span className="field-error">{validations.locations}</span>
              </Col>

              <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
                <div className="field-title">
                  Department
                  {/* <span style={{ color: "#FF4444" }}>*</span> */}
                </div>
                <CommonAsyncSelect isMulti cacheOptions value={selectedDept} loadOptions={getDepartmentData} onChange={handleDeptChange} defaultOptions placeholder="Select departments" />
                <span className="field-error">{validations.departments}</span>
              </Col>

              <Col xs={12} sm={12} className="mt-3">
                {/* Dimension Label with Divider and Unit */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "12px",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      fontFamily: "Epilogue",
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#172B4D",
                      whiteSpace: "nowrap",
                      marginRight: "10px",
                    }}
                  >
                    Dimension
                  </label>
                  <div
                    style={{
                      flex: 1,
                      borderBottom: "2px dashed #E5E5E5",
                      margin: "0 -10px",
                    }}
                  ></div>
                  <select
                    style={{
                      width: "90px",
                      height: "28px",
                      backgroundColor: "#fceaea",
                      border: "none",
                      borderRadius: "16px",
                      fontSize: "13px",
                      fontWeight: "500",
                      padding: "0 10px",
                      color: "#333",
                      marginLeft: "12px",
                    }}
                    value={dimension}
                    onChange={(event) => {
                      setDimension(event.target.value); // Update state with input value
                    }}
                  >
                    <option value="meter" selected>Meters</option>
                    <option value="cm">CM</option>
                    <option value="lg">LG</option>
                  </select>
                </div>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Length </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={length}
                  onChange={(event) => {
                    setLength(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error" >{validations.length}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Breadth </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={width}
                  onChange={(event) => {
                    setWidth(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error" >{validations.width}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Height </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={height}
                  onChange={(event) => {
                    setHeight(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error" >{validations.height}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Load In (hrs)<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="HH:MM (e.g. 01:30)"
                  className="input-field mt-1 w-100"
                  value={loadInDuration}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^[0-9:]*$/.test(inputText) && inputText.length <= 5) {
                      if (lastKey === "Backspace") {
                        setLoadInDuration(inputText);
                      } else {
                        setLoadInDuration(inputText.length === 2 && !inputText.includes(":") ? inputText + ':' : inputText);
                      }
                    }
                  }}
                  onBlur={(e) => {
                    const formatted = formatTimeOnBlur(e.target.value);
                    setLoadInDuration(formatted);
                    const err = validateTimeFormat(formatted, true, "Load In");
                    setValidations((prev) => ({ ...prev, load_in_time: err }));
                  }}
                />
                <span className="field-error">{validations.load_in_time}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Load Out (hrs)<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="HH:MM (e.g. 01:30)"
                  className="input-field mt-1 w-100"
                  value={loadOutDuration}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^[0-9:]*$/.test(inputText) && inputText.length <= 5) {
                      if (lastKey === "Backspace") {
                        setLoadOutDuration(inputText);
                      } else {
                        setLoadOutDuration(inputText.length === 2 && !inputText.includes(":") ? inputText + ':' : inputText);
                      }
                    }
                  }}
                  onBlur={(e) => {
                    const formatted = formatTimeOnBlur(e.target.value);
                    setLoadOutDuration(formatted);
                    const err = validateTimeFormat(formatted, true, "Load Out");
                    setValidations((prev) => ({ ...prev, load_out_time: err }));
                  }}
                />
                <span className="field-error">{validations.load_out_time}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Lag Duration (HH:MM)</div>
                <input
                  type="text"
                  placeholder="HH:MM (e.g. 00:30)"
                  className="input-field mt-1 w-100"
                  value={lagDuration}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^[0-9:]*$/.test(inputText) && inputText.length <= 5) {
                      if (lastKey === "Backspace") {
                        setLagDuration(inputText);
                      } else {
                        setLagDuration(inputText.length === 2 && !inputText.includes(":") ? inputText + ':' : inputText);
                      }
                    }
                  }}
                  onBlur={(e) => {
                    const formatted = formatTimeOnBlur(e.target.value);
                    setLagDuration(formatted);
                    const err = formatted ? validateTimeFormat(formatted, false, "Lag Duration") : "";
                    setValidations((prev) => ({ ...prev, lag_duration: err }));
                  }}
                />
                <span className="field-error">{validations.lag_duration}</span>
              </Col>

            </Row>
            <div className="mt-4 px-1" style={{background:'#F8F8F8', padding:'8px', borderRadius:'8px'}}>
              {productTypeList.map((item,index) => (
  <div key={index} style={{width:'100%'}}>
    <Row className="px-0" style={{width:'100%',}}>
       <Col xs={12} sm={12} md={4} className="mt-1 px-0 ps-md-1" >
       <div className="ps-1">
                <div className="field-title mb-1">
                  Product Type
                  {/* <span style={{ color: "#FF4444" }}>*</span> */}
                </div>
                <CommonAsyncSelect isMulti value={item.product_types} loadOptions={(inputValue) => getProductTypeData(inputValue, index)} defaultOptions={cachedOptions} onMenuOpen={() => handleMenuOpen(index)} onChange={(selectedOptions)=>{handleProductTypeChange(index,selectedOptions)}} placeholder="Select product type" />
                </div>
              </Col>

               <Col xs={12} sm={12} md={8}>
               <Row style={{width:'100%'}}>               
     <Col xs={12} sm={12} md={4} className="mt-1 px-0 ps-md-1">
                <div className="field-title mb-1"> Load In (hrs)<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="HH:MM"
                  className="input-field mt-1 w-100"
                  value={item.load_in}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^[0-9:]*$/.test(inputText) && inputText.length <= 5) {
                      const tempList = [...productTypeList];
                      if (lastKey === "Backspace") {
                        tempList[index].load_in = inputText;
                      } else {
                        tempList[index].load_in = inputText.length === 2 && !inputText.includes(":") ? inputText + ':' : inputText;
                      }
                      setProductTypeList(tempList);
                    }
                  }}
                  onBlur={(e) => {
                    const formatted = formatTimeOnBlur(e.target.value);
                    const tempList = [...productTypeList];
                    tempList[index].load_in = formatted;
                    setProductTypeList(tempList);
                  }}
                />
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-1 px-0 ps-md-1">
                <div className="field-title mb-1"> Load Out (hrs)<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="HH:MM"
                  className="input-field mt-1 w-100"
                  value={item.load_out}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^[0-9:]*$/.test(inputText) && inputText.length <= 5) {
                      const tempList = [...productTypeList];
                      if (lastKey === "Backspace") {
                        tempList[index].load_out = inputText;
                      } else {
                        tempList[index].load_out = inputText.length === 2 && !inputText.includes(":") ? inputText + ':' : inputText;
                      }
                      setProductTypeList(tempList);
                    }
                  }}
                  onBlur={(e) => {
                    const formatted = formatTimeOnBlur(e.target.value);
                    const tempList = [...productTypeList];
                    tempList[index].load_out = formatted;
                    setProductTypeList(tempList);
                  }}
                />
              </Col>
              <Col xs={12} sm={12} md={3} className="mt-1 px-0 ps-md-1">
                <div className="field-title mb-1"> Lag Duration</div>
                <input
                  type="text"
                  placeholder="HH:MM"
                  className="input-field mt-1 w-100"
                  value={item.lag}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^[0-9:]*$/.test(inputText) && inputText.length <= 5) {
                      const tempList = [...productTypeList];
                      if (lastKey === "Backspace") {
                        tempList[index].lag = inputText;
                      } else {
                        tempList[index].lag = inputText.length === 2 && !inputText.includes(":") ? inputText + ':' : inputText;
                      }
                      setProductTypeList(tempList);
                    }
                  }}
                  onBlur={(e) => {
                    const formatted = formatTimeOnBlur(e.target.value);
                    const tempList = [...productTypeList];
                    tempList[index].lag = formatted;
                    setProductTypeList(tempList);
                  }}
                />
              </Col>
              <Col className="px-0" xs={12} sm={12} md={1} style={{ display:'flex', alignItems:'end',justifyContent:'end',  }}>
              <div onClick={()=>{
                if(item.id !== null && item.id !== ""){
                  setProductTypeRemovedId(prev => [...prev, item.id]);
                }
                const tempList = [...productTypeList];
                tempList.splice(index, 1);
                setProductTypeList(tempList);
              }} className="style-justify-center" style={{width:'40px', height:'40px', borderRadius:'50px', border:'1px solid #EBEBEB', cursor: 'pointer'}}>
                  <img src={closeIcon} alt="remove" className="btn-icon w-2 h-2" />         
              </div>
              </Col>
              </Row>
              </Col>
              </Row>
                
  </div>
))}

              <button className="mt-1"
                onClick={()=>{
                  const tempList = [...productTypeList];
                  tempList.push({ id:'', product_types:[], load_in: "", load_out: "", lag: "" });
                  setProductTypeList(tempList);
                }} 
                type="button"
                style={{
                  backgroundColor: "#D35258",
                  color: "#fff",
                  borderRadius: "12px",
                  padding: "8px 16px",
                  fontWeight: "600",
                  fontFamily: "Epilogue",
                  fontSize: "14px",
                  cursor: "pointer",
                  border: "none",
                  display:'flex',
                  alignItems:'center',
                  justifyContent:'center'
                }}
              >
                <span className="icon pe-1">
                  <img src={plus} alt="add" className="btn-icon w-2 h-2" />
                </span>
                Add
              </button>     
            </div> 

          </form>

          {/* Footer Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "24px",
              gap: "8px",
            }}
          >
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              style={{
                backgroundColor: "#fff",
                color: "#333",
                borderRadius: "12px",
                padding: "8px 24px",
                fontWeight: "600",
                border: "1px solid #ddd",
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
            >
              Cancel
            </button>
            <button
              onClick={submitVehicleType}
              type="button"
              disabled={isSubmitting}
              style={{
                backgroundColor: "#D35258",
                color: "#fff",
                borderRadius: "12px",
                padding: "8px 24px",
                fontWeight: "600",
                fontFamily: "Epilogue",
                fontSize: "14px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                border: "none",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                opacity: isSubmitting ? 0.7 : 1,
              }}
            >
              {isSubmitting && (
                <div
                  className="spinner-border spinner-border-sm text-light"
                  role="status"
                  style={{ width: "14px", height: "14px" }}
                ></div>
              )}
              {isSubmitting ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VehicleAdd;
